// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"buildControl_BuildControl__2PXyc","Label":"buildControl_Label__bi28O","Less":"buildControl_Less__1uluX","More":"buildControl_More__1Eabo"};